__turbopack_context__.v({
  "link": "underline-link-module-scss-module__ir_5Qa__link",
  "link_active": "underline-link-module-scss-module__ir_5Qa__link_active",
});
